export default __webpack_public_path__ + "static/media/check.09c66dbb.svg";